import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles/createTheme';

export const useStyles = makeStyles<Theme>()((theme) => ({
  wrapper: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: '4px 4px 0 0',
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '8px',
  },
  tabs: {},
  tabsScroller: {
    overflow: 'auto !important' as any,
  },
  tabContentWrapper: {},
  tab: {
    display: 'flex',
    fontSize: '16px',
    color: theme.palette.text.primary,
    textTransform: 'none',
    alignItems: 'center',

    '& .itemsCount': {
      padding: '0 10px',
      fontWeight: 500,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      color: theme.palette.text.secondary,
      borderRadius: '4px',
      marginLeft: '4px',
    },
  },
  tabRoot: {
    borderBottom: `2px solid ${theme.palette.grey[200]}`,
  },
  selectedTab: {
    color: theme.palette.primary.main,
    borderBottom: `2px solid ${theme.palette.primary.main}`,
    '& .itemsCount': {
      backgroundColor: theme.palette.primary.main,
    },
  },
  muiTabsIndicator: {
    display: 'none',
    backgroundColor: theme.palette.primary.main,
  },
  itemsCount: {},
}));
